import { HttpClient } from "@/shared/lib/http-client"
import { env } from "@/config/env"
import { planMapper, type PlanMapper } from "./plan.mapper"
import type { PlanDTO } from "./plan.dto"
import type { ProductPlan } from "../types"

export interface FetchPlansOptions {
  multiCurrency?: boolean
}

export interface IProductsService {
  /** Whether a plans backend is configured. */
  readonly isConfigured: boolean
  fetchPlans(ids: string[], options?: FetchPlansOptions): Promise<ProductPlan[]>
}

/**
 * Fetches plans from the product service (POST { ids } -> PlanDTO[])
 * and maps them to the domain model via the injected PlanMapper.
 */
export class ProductsService extends HttpClient implements IProductsService {
  readonly isConfigured: boolean
  private readonly mapper: PlanMapper

  constructor(baseURL: string, mapper: PlanMapper = planMapper) {
    super({ baseURL })
    this.mapper = mapper
    this.isConfigured = Boolean(baseURL)
  }

  async fetchPlans(ids: string[], options?: FetchPlansOptions): Promise<ProductPlan[]> {
    const uniqueIds = Array.from(new Set(ids.filter(Boolean)))
    if (uniqueIds.length === 0 || !this.isConfigured) return []

    const dtos = await this.post<PlanDTO[]>("", { ids: uniqueIds })
    return this.mapper.toDomainList(dtos ?? [], options)
  }
}

export const productsService: IProductsService = new ProductsService(env.VITE_PLANS_API_URL)
